<template>
  <cl-raised-tab-set class="tw-mb-4">
    <cl-raised-tab
      v-for="tab in tabs"
      :key="tab.type"
      :active="tab.type === model"
      :disabled="disabled"
      @click="() => updateModel(tab.type)"
    >
      <div class="tw-flex tw-gap-1 tw-items-center">
        {{ tab.name }}
      </div>
    </cl-raised-tab>
  </cl-raised-tab-set>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { ref } from "vue";

const { t } = useI18n();

export type BrandingTabType =
  "branding-tab-company-name" | "branding-tab-company-logo";

type BrandingTab = {
  type: BrandingTabType;
  testId: string;
  name: string;
  active: boolean;
};

defineProps<{ disabled?: boolean }>();

const tabs = ref<BrandingTab[]>([
  {
    type: "branding-tab-company-name",
    testId: "msp-branding-tabs-company-name-tab",
    name: t("company-name-tab"),
    active: true,
  },
  {
    type: "branding-tab-company-logo",
    testId: "msp-branding-tabs-company-logo-tab",
    name: t("company-logo"),
    active: false,
  },
]);

const model = defineModel<BrandingTabType>();
const updateModel = (value: BrandingTabType) => (model.value = value);
</script>
